import { PHONE_POINTS } from "../lib/phoneOverview";
import { SET_TABLE, previewTable } from "../lib/phoneSetTable";

/* W72 step 3 — "ON THE CLIENT'S PHONE": the exercise INSIDE the player, as the client logs it, with `–` where the
 * numbers go (his 2026-09-25 note). Ported from `SetLogTable.swift` / `SectionExecutionView.swift`: the columns
 * and their order are the generated `playerColumns.ts`, the sizes are `SET_TABLE` (each ruled against the Swift),
 * and it re-draws as the coach edits — drag `Weight` above `Reps` and KG moves ahead of REPS here, because it
 * moves on the phone. Sizes are phone POINTS through `--pt`, the W66 frame's own unit. */
const VARS = {
  "--st-set": SET_TABLE.setW, "--st-rest": SET_TABLE.restW,
  "--st-tick": SET_TABLE.tickW, "--st-row": SET_TABLE.rowMinHeight, "--st-head": SET_TABLE.headerSize,
  "--st-head-track": SET_TABLE.headerTracking, "--st-label": SET_TABLE.setLabelSize,
  "--st-number": SET_TABLE.numberSize, "--st-rest-text": SET_TABLE.restSize,
  "--st-tick-size": SET_TABLE.tickSize, "--st-mark": SET_TABLE.markAllSize,
} as React.CSSProperties;

export function PhoneExercisePreview({ name, trackingFields, hasVideo }: {
  name: string;
  trackingFields: readonly string[];
  hasVideo: boolean;
}) {
  const { columns, rows } = previewTable(trackingFields);
  const cls = (c: string) => "px-cell px-" + c.toLowerCase();
  return (
    <div className="phone-frame" style={{ aspectRatio: `${PHONE_POINTS.width} / ${PHONE_POINTS.height}` }}
         role="img" aria-label={`How ${name || "this exercise"} looks on the client's phone while they train`}>
      <div className="phone-screen px-screen" style={VARS}>
        <div className="px-video" aria-hidden="true">
          {hasVideo ? <span className="px-play">▶</span> : <span className="px-novideo">No video yet</span>}
        </div>
        <p className="px-title">{name || "Exercise name"}</p>
        <div className="px-table">
          <div className="px-row px-head">
            {columns.map((c) => <span key={c} className={cls(c)}>{c}</span>)}
            <span className="px-cell px-tickcol" />
          </div>
          {rows.map((cells, r) => (
            <div key={r} className={r === 0 ? "px-row is-live" : "px-row"}>
              {cells.map((cell) => <span key={cell.column} className={cls(cell.column)}>{cell.text}</span>)}
              <span className="px-cell px-tickcol"><span className="px-tick" /></span>
            </div>
          ))}
        </div>
        <p className="px-markall">Mark all</p>
      </div>
    </div>
  );
}
